import { isAxiosError } from 'axios';
import { axiosAuth } from '@/axios';
import { Endpoints } from '@/enums';
import { NewPasswordData } from '@/types/auth';

export const resetPassword = async (
  newPasswordData: NewPasswordData
): Promise<unknown> => {
  try {
    const res = await axiosAuth.post(Endpoints.ResetPassword, {
      ...newPasswordData,
    });
    return res;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
